import { cn } from '@/lib/utils'

const tones = {
  primary: 'bg-primary-50 text-primary-800 ring-primary-200',
  accent: 'bg-accent-50 text-accent-800 ring-accent-200',
  neutral: 'bg-ink-100 text-ink-700 ring-ink-200',
  success: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  danger: 'bg-rose-50 text-rose-800 ring-rose-200',
  muted: 'bg-white text-ink-600 ring-ink-200',
}

export function Badge({ tone = 'neutral', size = 'sm', children, className, leftIcon }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 ring-1 ring-inset font-semibold',
        size === 'xs' ? 'h-5 text-[10px] tracking-wide' : 'h-6 text-xs',
        tones[tone] || tones.neutral,
        className,
      )}
    >
      {leftIcon}
      {children}
    </span>
  )
}
